import { media } from 'theme/breakpoints';
import styled from 'styled-components';

export const Border = styled.div`
  border-top: 1px solid #e4e5e8;
  ${media.tablet} {
    display: none;
  }
`;
